import { render } from "./NavbarNoti.vue?vue&type=template&id=89e46e54&scoped=true"
import script from "./NavbarNoti.vue?vue&type=script&lang=js"
export * from "./NavbarNoti.vue?vue&type=script&lang=js"

import "./NavbarNoti.vue?vue&type=style&index=0&id=89e46e54&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89e46e54"]])

export default __exports__